import {graphqlRequest} from '@shopify/cli-kit/node/api/graphql';
import {AbortError} from '@shopify/cli-kit/node/error';
import {Logger, outputCompleted} from '@shopify/cli-kit/node/output';

import {errorHandler, Header} from '../utils/utils.js';

import {
  DeploymentConfig,
  DeploymentManifestFile,
  EnvironmentInput,
} from './types.js';
import {
  DeploymentInitiateQuery,
  DeploymentInitiateQueryData,
  DeploymentInitiateResponse,
} from './graphql/deployment-initiate.js';

type DeploymentInitiateInput =
  | {
      buildId: string;
      environment?: never;
      labels?: string[];
      manifest: DeploymentManifestFile[];
    }
  | {
      environment?: EnvironmentInput;
      buildId?: never;
      labels?: string[];
      manifest: DeploymentManifestFile[];
    };

interface DeploymentInitiateOptions {
  config: DeploymentConfig;
  input: DeploymentInitiateInput;
  logger: Logger;
}

export async function deploymentInitiate(
  options: DeploymentInitiateOptions,
): Promise<DeploymentInitiateResponse> {
  const {config, input, logger} = options;

  const variables = {
    buildId: input.buildId,
    environment: input.environment,
    files: input.manifest,
    labels: input.labels,
  };

  try {
    const response: DeploymentInitiateQueryData = await graphqlRequest({
      query: DeploymentInitiateQuery,
      api: 'Oxygen',
      url: `${config.deploymentUrl}/api/v2/admin/graphql`,
      token: config.deploymentToken.accessToken,
      variables,
      addedHeaders: {
        [Header.OxygenNamespaceHandle]: config.deploymentToken.namespace,
      },
    });

    if (response.deploymentInitiate.userErrors.length >= 1) {
      throw new AbortError(
        `Failed to create deployment. ${response.deploymentInitiate.userErrors[0]?.message}`,
      );
    }

    outputCompleted(
      `Deployment initiated, ${response.deploymentInitiate.deploymentTargets.length} files to upload.`,
      logger,
    );
    return response.deploymentInitiate;
  } catch (error) {
    errorHandler(error);

    throw error;
  }
}
